import React from 'react';
import PropTypes from 'prop-types';

import { Badge } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';

export default class Tag extends React.Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    label: PropTypes.string,
    name: PropTypes.any,
    removable: PropTypes.bool,
    onRemove: PropTypes.func
  };

  static defaultProps = {
    removable: false,
  };

  manageRemove = (e) => {
    if (this.props.onRemove != null) {
      this.props.onRemove(e, this.props.name);
    }
  };

  render() {
    return (
      <Badge bg="" className="badge-secondary badge-muted text-nowrap">
        <div className="d-flex align-items-center">
          {this.props.label && `${this.props.label}: `}
          {this.props.children}
          {this.renderCloseLink()}
        </div>
      </Badge>
    );
  }

  renderCloseLink() {
    if (!this.props.removable) {
      return null;
    }

    return (
      <>
        &nbsp;
        <FontAwesomeIcon
          className="ms-1 clickable"
          icon={faTimesCircle}
          name="remove-control"
          size="1x"
          onClick={this.manageRemove}
        />
      </>
    );
  }
}
